module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('sticky', [(_vm.characters) ? _c('section', {
    staticClass: "shadow"
  }, [_vm._l((_vm.characters), function(character) {
    return _c('character-panel', {
      key: character.characterId,
      attrs: {
        "character-id": character.characterId,
        "opened": _vm.opened
      },
      on: {
        "selected": _vm.onSelected
      }
    })
  }), _vm._v(" "), _c('character-panel', {
    key: "panel-vault",
    attrs: {
      "character-id": "VAULT",
      "opened": _vm.opened
    },
    on: {
      "selected": _vm.onSelected
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.opened),
      expression: "!opened"
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openMenu($event)
      }
    }
  })], 2) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e9a460a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Panels.vue
// module id = 552
// module chunks = 1